import { FC } from 'react';
import { SvgIcon } from '@edikk-edikk/svg-icon';
import LocationSvg from '@edikk-edikk/country-layout-black-icon/src/location.svg';
import LocationAltSvg from '@edikk-edikk/country-layout-black-icon/src/location-alt.svg';
import { useClassNamesWithStyle, useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import cardHeaderCss from '#srcCssModules/card/card-header.module.scss';
import cardHeaderIconCss from '#srcCssModules/card/card-header-icon.module.scss';

const CardLocationHeader: FC = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <div className={cardHeaderCss.cardHeader}>
      <div
        className={classNamesWithStyle(
          cardHeaderIconCss.cardHeaderIcon,
          cardHeaderIconCss.cardHeaderIcon_styleDefault,
          cardHeaderIconCss.cardHeaderIcon_styleRed,
        )}
      >
        <SvgIcon
          Component={isFrontendStyleRed ? LocationAltSvg : LocationSvg}
          isWithoutStroke
          additionalClassName={cardHeaderIconCss.cardHeaderIcon__content}
        />
      </div>
    </div>
  );
};

export { CardLocationHeader };
